import React, { useEffect, useState } from "react";
import { Button, Pagination, TuneIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import Table from "~/components/Table";
import useGetDealerIvideonById from "~/entity/Ivideon/hooks/useGetDealerIvideonById";
import Wrapper from "~/shared/ui/Wrapper";
import {
  defaultValueCamerasFilterIProps,
  useGetIvideonHistoryCameras,
} from "~/entity/Ivideon";
import { cleanFilters } from "~/entity/Ivideon/lib/cleanFilters";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import { usePaginationParams } from "~/shared/hooks/usePaginationParams";

import HistoryCamerasFilter from "./HistoryCamerasFilter";
import { fromServer } from "./helper";
import { defaultValueCamerasFilter } from "./HistoryCamerasFilter/options";
import { HISTORY_CAMERAS } from "./options";

import s from "./HistoryCameras.less";

export default function HistoryCameras() {
  const [filters, setFilters] = useState<defaultValueCamerasFilterIProps>(
    () => {
      const saved = sessionStorage.getItem("filterCameras");
      return saved ? JSON.parse(saved) : defaultValueCamerasFilter;
    },
  );
  const { dealerId } = useParams<{
    dealerId: string;
  }>();
  const { count, page, openModal, cameraId, cameraName } = useURLParamsGetter<{
    count: string;
    page: string;
    openModal: string;
    cameraId: string;
    cameraName: string;
  }>();
  const setURLParams = useURLParamsSetter();
  const { t } = useTranslation();
  const { data, isLoading, isError, getParams } = useGetIvideonHistoryCameras();
  const { data: dataDealer, getRequestParams } = useGetDealerIvideonById();

  const handleApplyFilters = (newFilters: defaultValueCamerasFilterIProps) => {
    setFilters(newFilters);
    sessionStorage.setItem("filterCameras", JSON.stringify(newFilters));
  };

  useEffect(() => {
    if (dealerId) {
      getRequestParams(`dealerSearch[ids][]=${dealerId}`);
    }
  }, [dealerId]);

  useEffect(() => {
    if (dealerId) {
      const activeFilters = cleanFilters(filters);
      getParams({
        dealerId: Number(dealerId),
        page: page ? Number(page) : 0,
        limit: count ? Number(count) : 25,
        ...(cameraId ? { cameraIvideonId: cameraId } : {}),
        ...activeFilters,
      });
    }
  }, [dealerId, count, page, filters, cameraId]);

  const getIvideonHistoryCameras = (data: defaultValueCamerasFilterIProps) => {
    const activeFilters = cleanFilters(data);
    handleApplyFilters(data);
    getParams({
      dealerId: Number(dealerId),
      page: page ? Number(page) : 0,
      limit: count ? Number(count) : 25,
      ...(cameraId ? { cameraIvideonId: cameraId } : {}),
      ...activeFilters,
    });
  };

  const { handleCount, handlePage } = usePaginationParams("urlParams");

  const dealerName = dataDealer?.dealers[0]?.name ?? "";

  const openFilter = () => {
    setURLParams({ openModal: "open" });
  };

  return (
    <>
      <Wrapper.Content
        title={
          cameraName
            ? `История камеры "${cameraName}"`
            : `История камер ${dealerName}`
        }
        goBackHandler={() => window.close()}
        txtBtn="назад"
        controlComponent={
          <Button
            size="middle"
            fontSize="12"
            color="secondary"
            icon={<TuneIcon />}
            onClick={openFilter}
          >
            Фильтры
          </Button>
        }
      >
        <Table
          options={HISTORY_CAMERAS}
          items={data ? fromServer({ data, t }) : []}
          loading={isLoading}
          type="ivideonCameras.camerasHistory"
          customClassName={s.tableCustomStyles}
        />
        <Pagination
          count={Number(count) || 25}
          page={(Number(page) || 0) + 1}
          totalCount={data?.total ?? 1}
          onChangeCount={handleCount}
          onChangePage={handlePage}
        />
      </Wrapper.Content>
      <HistoryCamerasFilter
        openModal={openModal}
        initialValues={filters}
        getIvideonHistoryCameras={getIvideonHistoryCameras}
      />
    </>
  );
}
